import Grid from '@mui/material/Grid2'
import Link from '@mui/material/Link'
import React from 'react'

const PlayWithUs: React.FC = () => {
  return (
    <Grid
      container
      direction="column"
      spacing={4}
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Grid size={10}>
        <h1>Börja spela med oss</h1>
        <h2>Alla är välkomna! Du kan vara nybörjare eller erfaren</h2>
      </Grid>

      <Grid size={{ xs: 11, md: 6 }} textAlign="start">
        <p>Vi har instrument att låna i viss mån</p>
        <p>Vi anpassar stämmor efter din nivå och ditt instrument</p>

        <div>
          <b>Kostnad för medlemskap:</b>
          <ul>
            <li>Över 18år: 200kr / termin</li>
          </ul>
        </div>

        <p>
          <b>Resor och evenemang:</b> Vi åker bland annat till Lübeck, vilket
          innebär en kostnad för deltagare
        </p>
        <p>
          <b>Eget instrument på sikt:</b> Om du fortsätter spela hos oss kan det
          bli aktuellt att köpa ett eget instrument
        </p>
        <p>
          <b>Så tar du kontakt:</b> Anmäl dig via{' '}
          <Link href="/contact">
            <b>kontaktformuläret</b>
          </Link>{' '}
          eller kom förbi en repetition
        </p>
      </Grid>

      <Grid size={{ xs: 11, md: 6 }}>
        <h4>
          Här övar vi varje måndag: 18:30-ca 20:45, med insluss från 17:30
        </h4>
        <iframe
          title="Google maps karta"
          src="https://google.com"
          width="100%"
          height={450}
          style={{
            border: 0,
            borderRadius: 10,
          }}
        />
      </Grid>
    </Grid>
  )
}

export default PlayWithUs
